import { render } from "./servicesAR.vue?vue&type=template&id=3241a566&scoped=true"
import script from "./servicesAR.vue?vue&type=script&lang=js"
export * from "./servicesAR.vue?vue&type=script&lang=js"

import "./servicesAR.vue?vue&type=style&index=0&id=3241a566&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3241a566"]])

export default __exports__